angular.module('rjmNg').config [
  "$routeProvider"
  "$locationProvider"
  "$httpProvider"
  "$provide"
  "$windowProvider"
  ($routeProvider, $locationProvider, $httpProvider, $provide, $windowProvider) ->
    $window = $windowProvider.$get()
    urlClientIdParam = () ->
      STATIC_URL_PARAM_MATCHER = /\/v2\/client\/(\d+)\/dashapp/

      match = $window.location.pathname.match(STATIC_URL_PARAM_MATCHER)
      return unless match?

      [..., clientIdStr] = match

      clientId = parseInt(clientIdStr)
      return if isNaN(clientId)

      clientId

    $provide.decorator("$exceptionHandler", ['Raven', '$delegate', (Raven, $delegate) ->
      (exception, cause) ->
        $delegate(exception, cause)
        Raven.captureException(exception)
    ])

    _getQueryParams = (search) ->
      queryParams = angular.copy(search)
      queryParams = _.mapObject(queryParams, (val,key) ->
        encodeURIComponent(key) + "=" + encodeURIComponent(val)
      )
      return _.values(queryParams).join('&')

    getPermsResolver = (validateFn) ->
      return ['$location', '$route', '$q', 'app', 'appRoute', ($location, $route, $q, app, appRoute) -> 
          deffered = $q.defer()
          if(validateFn(app))
            deffered.resolve(true)
          else
            console.log('Wrong Permissions')
            $location.path(appRoute('/', $route.current.params.clientId))
            deffered.reject()
          return deffered.promise
        ]
        
    persistentViewsPerms = getPermsResolver((app) -> return app.isAdminUser() and app.hasFeatureFlag('PERSISTENT_VIEWS'))
    adminPerms = getPermsResolver((app) -> return app.isAdminUser())
    graphicalEmailSummaryPerms = getPermsResolver((app) -> return app.hasFeatureFlag('GRAPHICAL_EMAIL_SUMMARY'))
    legacyEmailSummaryPerms = getPermsResolver((app) -> return not app.hasFeatureFlag('HIDE_LEGACY_EMAIL_SUMMARY'))
    integrationsUIPerms = getPermsResolver((app) -> return not app.hasFeatureFlag('DISABLE_INTEGRATIONS_UI'))

    APP_BASE_URL = "/client/:clientId/dashapp"

    $locationProvider.html5Mode
      enabled: true
      requireBase: false
    $httpProvider.interceptors.push 'httpErrorHandler'
    $httpProvider.xsrfWhitelistedOrigins.push $window.rjm.app.params?.serviceRoot
    $routeProvider.when APP_BASE_URL+"/",
      template: "<re-route></re-route>"

    # Builders
    .when APP_BASE_URL+"/reports/",
      templateUrl: "reports/report.selection.html"
      pageTitle: "Select Report Type"
    .when APP_BASE_URL+"/reports/sql",
      templateUrl: "reports/sql.html"
      pageTitle: "SQL Report Builder"
    .when APP_BASE_URL+"/reports/sql/:figureId",
      templateUrl: "reports/sql.html"
      pageTitle: "SQL Report Builder"
    .when APP_BASE_URL+"/reports/create/",
      template: "<visual-report-builder></visual-report-builder>"
      pageTitle: "Report Builder"
    .when APP_BASE_URL+"/reports/:figureId",
      template: "<visual-report-builder></visual-report-builder>"
      pageTitle: "Report Builder"
    .when APP_BASE_URL+"/:dashId",
      controller: 'DashWrapperCtrl'
      templateUrl: "dash.html"
    .when APP_BASE_URL+"/chartBuilder/create",
      controller: 'ChartBuilderCtrl'
      templateUrl: "chart.edit.html"
    .when APP_BASE_URL+"/chartBuilder/:chartId",
      controller: 'ChartBuilderCtrl'
      templateUrl: "chart.edit.html"

    # Integrations
    .when APP_BASE_URL+"/settings/connection/",
      template: "<all-connections></all-connections>"
      pageTitle: "Integrations"
    .when APP_BASE_URL+"/settings/connection/add",
      template: "<connection-picker></connection-picker>"
      pageTitle: "Add Integrations"
      resolve:
        canView: integrationsUIPerms
    .when APP_BASE_URL+"/settings/connection/create/:connectionType/:connectionSubtype/",
      resolveRedirectTo: ['$location', '$route', 'app', ($location, $route, app) ->
        queryParams = _getQueryParams($location.search())

        BASE_URL = "/client/#{$route.current.params.clientId}/dashapp"
        if (not integrationsUIPerms)
          APP_BASE_URL+"/settings/connection/"
        else if($location.search().feature is "AdWords")
          BASE_URL+"/settings/connection/create/google-adwords?#{queryParams}"
        else if($location.search().feature is "Ecommerce")
          BASE_URL+"/settings/connection/create/google-ecommerce?#{queryParams}"
        else if($location.search().feature is "Analytics4Live")
          BASE_URL+"/settings/connection/create/google-analytics4-live?#{queryParams}"
        else if ($location.search().feature is "Analytics")
          if(app.isMagentoChannels() && !app.clientIsImplemented())
            BASE_URL+"/magento/connect/googleAnalytics/?#{queryParams}"
          else
            BASE_URL+"/settings/connection/create/google-analytics?#{queryParams}"
      ]
    .when APP_BASE_URL+"/settings/connection/create/:connectionType/",
      template: "<connection-editor></connection-editor>"
      pageTitle: "Create Integration"
      resolve:
        canView: integrationsUIPerms
    .when APP_BASE_URL+"/settings/connection/:connectionType/:connectionId/",
      template: "<connection-editor></connection-editor>"
      pageTitle: "Edit Integration"
      resolveRedirectTo: ['$location', '$route', 'app', ($location, $route, app) ->
        BASE_URL = "/client/#{$route.current.params.clientId}/dashapp"
        queryParams = _getQueryParams($location.search())
        if (not integrationsUIPerms)
          return APP_BASE_URL+"/settings/connection/"
        else if($route.current.params.connectionType is 'ad-words' && app.isMagentoChannels() && !app.clientIsImplemented())
          return BASE_URL + "/magento/connect/googleAdwords/#{$route.current.params.connectionId}?#{queryParams}"
        else
          return undefined
      ]
    .when APP_BASE_URL+"/settings/connection/:connectionId/",
      template: "<connection-editor></connection-editor>"
      pageTitle: "Edit Integration"
      resolve:
        canView: integrationsUIPerms

    # PDW
    .when APP_BASE_URL+"/settings/datatarget/",
      template: "<pdw-edit-data-target-form></pdw-edit-data-target-form>"
      pageTitle: "Create Private Data Warehouse"
    .when APP_BASE_URL+"/settings/datatarget/:connectionId/",
      template: "<pdw-edit-data-target-form></pdw-edit-data-target-form>"
      pageTitle: "Edit Private Data Warehouse"

    # Settings
    .when APP_BASE_URL+"/settings/billing/",
      template: "<billing></billing>"
      pageTitle: "Subscription and Billing"
    .when APP_BASE_URL+"/settings/upload/",
      templateUrl: "settings/fileupload.html"
      pageTitle: "File Uploads"
    .when APP_BASE_URL+"/settings/email-summary/", #Graphical Email Summary
      template: "<email-summary-list></email-summary-list>"
      pageTitle: "Email Summaries"
      resolve:
        canView: graphicalEmailSummaryPerms
    .when APP_BASE_URL+"/settings/email-summary/edit", #Graphical Email Summary
      template: "<email-summary-edit></email-summary-edit>"
      pageTitle: "Email Summaries"
      resolve:
        canView: graphicalEmailSummaryPerms
    .when APP_BASE_URL+"/settings/email-summary/edit/:esId", #Graphical Email Summary
      template: "<email-summary-edit></email-summary-edit>"
      pageTitle: "Email Summaries"
      resolve:
        canView: graphicalEmailSummaryPerms
    .when APP_BASE_URL+"/settings/emailsummary/", #OLD Email Summary
      templateUrl: "settings/emailsummary.list.html"
      pageTitle: "Email Summaries"
      resolve:
        canView: legacyEmailSummaryPerms
    .when APP_BASE_URL+"/settings/emailsummary/:esid/:esumAction", #OLD Email Summary
      templateUrl: "settings/emailsummary.edit.html"
      pageTitle: "Email Summary"
      resolve:
        canView: legacyEmailSummaryPerms
    .when APP_BASE_URL+"/settings/emailsummary/:esumAction", #OLD Email Summary
      templateUrl: "settings/emailsummary.edit.html"
      pageTitle: "Email Summary"
      resolve:
        canView: legacyEmailSummaryPerms
    .when APP_BASE_URL+"/settings/personal",
      template: "<user-profile></user-profile>"
      pageTitle: "Personal Information"
    .when APP_BASE_URL+"/settings/user/invite",
      template: "<invite-user></invite-user>"
      pageTitle: "Invite a User"
    .when APP_BASE_URL+"/settings/user/access-group",
      template: "<access-group></access-group>"
      pageTitle: "Configure Access Group"
    .when APP_BASE_URL+"/settings/users",
      template: "<manage-users></manage-users>"
      pageTitle: "Manage Users"
    .when APP_BASE_URL+"/settings/account",
      template: "<client-settings></client-settings>"
      pageTitle: "Account Settings"
    .when APP_BASE_URL+"/settings/data-warehouse/",
      template: "<data-data-warehouse></data-data-warehouse>"
      pageTitle: "Data Warehouse"
    .when APP_BASE_URL+"/settings/persistent-views",
      template: "<persistent-views></persistent-views>"
      pageTitle: "Data Warehouse Views"
      resolve: 
        canView: persistentViewsPerms
    .when APP_BASE_URL+"/settings/persistent-views/view",
      template: "<create-data-ware-house-view></create-data-ware-house-view>"
      pageTitle: "Data Warehouse Views"
      resolve: 
        canView: persistentViewsPerms
    .when APP_BASE_URL+"/settings/persistent-views/view/:viewId",
      template: '<create-data-ware-house-view></create-data-ware-house-view>'
      pageTitle: "Data Warehouse Views"
      resolve: 
        canView: persistentViewsPerms
    .when APP_BASE_URL+"/settings/data-warehouse/table/:tableId",
      template: "<data-data-warehouse></data-data-warehouse>"
      pageTitle: "Data Warehouse"
    .when APP_BASE_URL+"/settings/data-warehouse/table/",
      template: "<data-data-warehouse></data-data-warehouse>"
      pageTitle: "Data Warehouse"
    .when APP_BASE_URL+"/settings/metric/",
      template: "<metrics-manage></metrics-manage>",
      pageTitle: "Metrics"
    .when APP_BASE_URL+"/settings/metric/edit",
      template: "<metric-edit></metric-edit>"
      pageTitle: "Metrics"
      resolve:
        canView: adminPerms
    .when APP_BASE_URL+"/settings/metric/edit/:metricId",
      template: "<metric-edit></metric-edit>"
      pageTitle: "Metrics"
      resolve:
        canView: adminPerms
    .when APP_BASE_URL+"/settings/filter-set/",
      template: "<filter-sets></filter-sets>"
      pageTitle: "Filter Sets"
    .when APP_BASE_URL+"/settings/filter-set/create",
      template: "<filter-sets></filter-sets>"
      pageTitle: "Filter Sets"
    .when APP_BASE_URL+"/settings/filter-set/:id",
      template: "<filter-sets></filter-sets>"
      pageTitle: "Filter Sets"
    .when APP_BASE_URL+"/settings/filter-set/clone/:id",
      template: "<filter-sets></filter-sets>"
      pageTitle: "Filter Sets",
    .when APP_BASE_URL+"/settings/manage-reports/",
      template: "<manage-reports></manage-reports>"
      pageTitle: "Reports"
    .when APP_BASE_URL+"/settings/systemsummary/",
      templateUrl: "settings/systemsummary.html"
      pageTitle: "System Summary"
    .when APP_BASE_URL+"/settings/export-api/",
      template: "<export-api></export-api>"
      pageTitle: "Export API"
    .when APP_BASE_URL+"/settings/welcome",
      controller: "noDashboardRouterCtrl"
      pageTitle: "Adobe Commerce Intelligence"
      template: "<div></div>"
    .when APP_BASE_URL+"/settings/raw-export/",
      template: "<raw-export></raw-export>"
      pageTitle: "Raw Export"
    .when APP_BASE_URL+"/settings/paths/",
      template: "<path-settings></path-settings>"
      pageTitle: "Paths"

    # Magento Basic Tier Onboarding
    .when APP_BASE_URL+"/magento/preferences",
      pageTitle: "Set your preferences"
      template: "<magento-preferences></magento-preferences>"
    .when APP_BASE_URL+"/magento/database/:type",
      pageTitle: "Connect your Magento database"
      template: "<magento-connect-database></magento-connect-database>"
    .when APP_BASE_URL+"/magento/database/:type/:connectionId",
      pageTitle: "Connect your Magento database"
      template: "<magento-connect-database></magento-connect-database>"
    .when APP_BASE_URL+"/magento/invite",
      pageTitle: "Invite a team member"
      template: "<invite-team-members></invite-team-members>"
    .when APP_BASE_URL+"/magento/connect/googleAdwords/",
      pageTitle: "Connect Google AdWords"
      template: "<signup-channels-google-ads></signup-channels-google-ads>"
    .when APP_BASE_URL+"/magento/connect/googleAdwords/:connectionId",
      pageTitle: "Connect Google AdWords"
      template: "<signup-channels-google-ads></signup-channels-google-ads>"
    .when APP_BASE_URL+"/magento/connect/mysql/start",
      pageTitle: "Connect your Magento database"
      template: '<signup-channels-mysql init-state="1"></signup-channels-mysql>'
    .when APP_BASE_URL+"/magento/connect/mysql/preferences",
      pageTitle: "Connect your Magento database"
      template: '<signup-channels-mysql init-state="2"></signup-channels-mysql>'
    .when APP_BASE_URL+"/magento/connect/mysql/",
      pageTitle: "Connect your Magento database"
      template: '<signup-channels-mysql init-state="3"></signup-channels-mysql>'
    .when APP_BASE_URL+"/magento/connect/mysql/:connectionId",
      pageTitle: "Connect your Magento database"
      template: '<signup-channels-mysql init-state="3"></signup-channels-mysql>',
    .when APP_BASE_URL+"/magento/connect/googleAnalytics/",
      pageTitle: "Connect Google Analytics"
      template: "<signup-channels-google-analytics></signup-channels-google-analytics>"
    .when APP_BASE_URL+"/magento/connect/googleAnalytics/:connectionId",
      pageTitle: "Connect Google Analytics"
      template: "<signup-channels-google-analytics></signup-channels-google-analytics>"
    .when APP_BASE_URL+"/magento/connect/success",
      pageTitle: "You Are Connected"
      template: "<signup-channels-success></signup-channels-success>"

    # Login
    .when "/session/create",
      pageTitle: "Sign In"
      template: "<login></login>"
      inApp: false
    .when "/session/recovery",
      pageTitle: "Password Recovery"
      template: "<login></login>"
      inApp: false

    # Signup
    .when "/magento/signup",
      pageTitle: "Signup for Adobe Commerce Intelligence"
      template: "<magento-signup></magento-signup>"
      inApp: false
    .when "/invites/:token",
      pageTitle: "Create your password"
      template: "<invite></invite>"
      inApp: false
    .when "/magento/login",
      pageTitle: "Enter your password"
      template: "<magento-login></magento-login>"
      inApp: false

    # Password Resets
    .when "/resets/:userId/:resetToken",
      pageTitle: "Reset Password"
      template: "<reset-password></reset-password>"
      inApp: false

    .otherwise redirectTo: () ->
      clientId = urlClientIdParam()

      # This is necessary in order to redirect to the login page when
      # a backbone page refreshes but user's session has expired
      unless clientId?
        return "/session/create?redirect=#{$window.location}"

      "/client/#{clientId}/dashapp"
    
    
]
.run [
  "$location"
  "appParams"
  (
   $location
   appParams
  ) ->

    loc =
      week:
        dow: appParams?.weekStartDay ? 0

    moment.updateLocale('en', loc)

    IN_APP_MATCHER = /\/client\/(\d+)\/([^\/]+)/

    match = $location.path().match(IN_APP_MATCHER)

    # Redirect to login page if we don't have a clientId but user
    # is on a "/client/:clientId/" prefixed location
    if match? and appParams.clientId is ""
      $location.path "/session/create"
]

